export const useWindowHeight = defineStore("window-height", () => {
  const windowHeight = ref<number>(0);

  const updateWindowHeight = () => {
    windowHeight.value = window.innerHeight;
  };

  return { windowHeight, updateWindowHeight };
});
